export default "__VITE_ASSET__m$_9Z1oI__"